module.exports = __webpack_public_path__ + "static/media/logo-new.85288d43.webp";